import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { InputWidthValues } from 'apps/webcomponents/src/ui/gzInput';

export const template = document.createElement('template');

template.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id="details-section">
    <div class="details-header-section">
      <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="integration-description" class="custom-space field-description"></gz-text>
      <div class="card-logo-container">
        <img id="integration-image" src="app/webcomponents/assets/images/integrations/bitdefender-logo.png"/>
      </div>
    </div>

    <div id="configuration-section">
      <gz-title fontSize="${FontSizes.HEADING_4}" fontWeight="${FontWeights.MEDIUM}" id="configuration-section-title"></gz-title>

      <gz-form-field id="integration-company-form-field" label="" required>
        <gz-single-select-complex gz-form-input labelWidth="240"></gz-single-select-complex>
        <gz-input-error></gz-input-error>
      </gz-form-field>
      <gz-form-field id="integration-name-form-field" label="" required>
        <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>
    </div>

    <div id="check-requirements-section" class="steps-section">
      <gz-title fontSize="${FontSizes.HEADING_4}" fontWeight="${FontWeights.MEDIUM}" id="check-requirements-header"></gz-title>
      <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="check-requirements-description"></gz-text>
    </div>

    <div id="connect-scanner-section" class="steps-section">
      <gz-title fontSize="${FontSizes.HEADING_4}" fontWeight="${FontWeights.MEDIUM}" id="connect-scanner-header"></gz-title>

      <gz-title fontSize="${FontSizes.PARAGRAPH_11}" fontWeight="${FontWeights.SEMIBOLD}" class="subsection-title" id="download-scanner-title"></gz-title>

      <gz-enumeration-icon value="1">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-step-1"></gz-text>
          <gz-copy-to-clipboard>
            <gz-textarea maxchars="500" rows="2" resizablebycontent gz-form-input inputWidth="${InputWidthValues.XXLARGE}" readonly id="connect-scanner-step-1-input"></gz-textarea>
          </gz-copy-to-clipboard>
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-step-1-text"></gz-text>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="2">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-step-2"></gz-text>
          <gz-copy-to-clipboard>
            <gz-input gz-form-input inputWidth="${InputWidthValues.XXLARGE}" readonly id="connect-scanner-step-2-input"></gz-input>
          </gz-copy-to-clipboard>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="3">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-step-3"></gz-text>
          <gz-copy-to-clipboard>
            <gz-input gz-form-input inputWidth="${InputWidthValues.XXLARGE}" readonly id="connect-scanner-step-3-input"></gz-input>
          </gz-copy-to-clipboard>
        </div>
      </gz-enumeration-icon>

      <gz-title fontSize="${FontSizes.PARAGRAPH_11}" fontWeight="${FontWeights.SEMIBOLD}" class="subsection-title" id="auth-scanner-title"></gz-title>

      <gz-enumeration-icon value="1">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-step-4"></gz-text>
          <gz-copy-to-clipboard>
            <gz-textarea maxchars="500" rows="2" resizablebycontent gz-form-input inputWidth="${InputWidthValues.XXLARGE}" readonly id="connect-scanner-step-4-input"></gz-textarea>
          </gz-copy-to-clipboard>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="2">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-step-5"></gz-text>
          <gz-copy-to-clipboard>
            <gz-input gz-form-input inputWidth="${InputWidthValues.XXLARGE}" readonly id="connect-scanner-step-5-input"></gz-input>
          </gz-copy-to-clipboard>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="3">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-step-6"></gz-text>
          <gz-copy-to-clipboard>
            <gz-textarea maxchars="500" rows="2" resizablebycontent gz-form-input inputWidth="${InputWidthValues.XXLARGE}" readonly id="connect-scanner-step-6-input"></gz-textarea>
          </gz-copy-to-clipboard>
        </div>
      </gz-enumeration-icon>
      <gz-enumeration-icon value="4">
        <div class="inner-steps-section">
          <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-step-7"></gz-text>
          <gz-copy-to-clipboard>
            <gz-input gz-form-input inputWidth="${InputWidthValues.XXLARGE}" readonly id="connect-scanner-step-7-input"></gz-input>
          </gz-copy-to-clipboard>
        </div>
      </gz-enumeration-icon>

      <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="connect-scanner-footer"></gz-text>
    </div>
  </div>
`;
